<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="p-1">
            <form class="" @submit.prevent="submitForm">
              <div class="row">
                <div class="form-group col-12 col-md-3">
                  <label for="phone24">Nombre:</label>
                  <b-form-input v-model="company.name" autocomplete="off"/>
                  <span v-if="validation_company.name" class="text-danger">
                                      {{ validation_company.name }}
                                    </span>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="phone24">Descripción:</label>
                  <b-form-input v-model="company.description" autocomplete="off"/>
                  <span v-if="validation_company.description" class="text-danger">
                                      {{ validation_company.description }}
                                    </span>
                </div>
              </div>
              <div class="row">
                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR_COMPANY_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
  getterType: 'companies/getField',
  mutationType: 'companies/updateField',
})

export default {
  name: "formView",
  components: {
    BCol,
    BRow,
    BCard,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      edit: false,
      showLoading: false,
    }
  },
  computed: {
    ...mapState('auxiliariesCompany', ['validation_company']),
    ...mapFields({
      company: 'company',
    }),
  },
  created() {
    this.$store.commit('auxiliariesCompany/RESET_STATE')
    this.$store.commit('auxiliariesCompany/CLEAR_VALIDATION')
    if (this.$route.params.id) {
      this.edit = true
      this.getCompany()
    } else {
      this.edit = false
    }
    this.$root.$refs.auxiliariesCompanyForm = this
  },
  methods: {
    getCompany() {
      this.showLoading = true
      this.$store.dispatch('companies/findCompany', {
        id: this.$route.params.id ?? this.company.id
      })
          .then(response => {
            this.showLoading = false
          })
          .catch(error => {
            this.showLoading = false
          })
    },
    cancel() {
      this.$router.push(GEI_AUXILIAR_COMPANY_LIST)
    },
    createAuxiliar() {
      this.$store.dispatch('companies/createCompany', this.company)
          .then(response => {
            helper.showToast('Empresa creada correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR_COMPANY_LIST)
          })
          .catch(error => {
            helper.showToast('Error al crear la empresa', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    updateAuxiliar() {
      this.$store.dispatch('companies/updateCompany', this.company)
          .then(response => {
            helper.showToast('Empresa editada correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR_COMPANY_LIST)
          })
          .catch(error => {
            helper.showToast('Error al editar la empresa', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    submitForm() {
      if (this.$route.params.id) {
        this.updateAuxiliar()
      } else {
        this.createAuxiliar()
      }
    },
  },
}
</script>